'use strict'

import { projectMode, settingsData, threeJsVariables } from '../../../settings';
import { rotateToCamera} from "../../controls/orbitControls";
import { ViewMode } from '../../../common';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import { Euler, Group, InstancedMesh, Matrix4, Mesh, MeshBasicMaterial, Quaternion, Vector3 } from 'three';
import { DoubleSide } from 'three';

let fontLoader = null;
let group = null;
let loadedFont = null;

export const createStreetNames = () => {

    if (projectMode.LiteMode.isActive()) return;

    const rtl = document.documentElement.getAttribute('dir') === 'rtl';
    if (!fontLoader) {
        fontLoader = new FontLoader();
    }
    
    if (!group) {
        group = new Group();
        group.name = 'streetsGroup';
    } else if (group && group.children.length) {
        group.traverse(el => {
            if (el.isMesh) {
                el.geometry.dispose();
                el.material.dispose();
                Promise.resolve().then(() => {
                    el.removeFromParent();
                })
            }
        });
    }
    
    const createText = (font) => {
        config.features.streets.forEach(street => {
            let message;
            if (rtl) {
                message = street.name.he;
                let messageArray = street.name.he.split('');
                message = '';
                messageArray.reverse().forEach(letter => message += letter);
            } else {
                message = street.name.en;
            }
            
            
            const textGeometry = new TextGeometry(
                message,
                {
                    font: font,
                    size: street?.size || 0.5,
                    depth: street?.height || 0.2,
                    curveSegments: 1,
                    bevelEnabled: true,
                    bevelThickness: 0.03,
                    bevelSize: 0.02,
                    bevelOffset: 0,
                    bevelSegments: 1,
                }
            );
            
            textGeometry.center();
            // const material = new THREE.MeshMatcapMaterial();
            const material = new MeshBasicMaterial({
                color: 0xffffff,
                side: DoubleSide
            });
            const text = new Mesh(textGeometry, material);
            
            text.name = `Street-${street.name.en}`;
            text.position.set(0, 0, 0);
            text.rotation.set(0, 0, 0);
            text.scale.set(street.scale.x, street.scale.y, street.scale.z);
            
            // streetsGroup.add(text);
            
            makeInstanceTextMesh(text, street.instances.length, street.instances, group);
            
            if (settingsData.activeModeSwitching){
                group.visible = false;
            }
            
        });
    };
    
    if (!loadedFont) {
        fontLoader.load('fonts/assistant/Assistant_Regular.json',(font) => {
            loadedFont = font;
            createText(font)
        });
    } else {
        createText(loadedFont);
    }
    
    threeJsVariables.scene.add(group);
    threeJsVariables.renderList.reorder();
    
    if (settingsData.activeViewMode !== ViewMode.Orbit){
        group.visible = false;
    }
}


function makeInstanceTextMesh(baseMesh, count, instanceConfig, streetsGroup) {
    const matrix = new Matrix4();
    const scale = new Vector3(baseMesh.scale.x, baseMesh.scale.y, baseMesh.scale.z);
    const textInstance = new InstancedMesh(baseMesh.geometry, baseMesh.material, count);
    //textInstance.instanceMatrix.setUsage(THREE.DynamicDrawUsage);

    instanceConfig.forEach((element, index) => {
        let rotation = new Euler(element.rotation.x, element.rotation.y, element.rotation.z, 'XYZ');
        let rotationQ = new Quaternion().setFromEuler(rotation);
        let position = new Vector3(element.position.x, element.position.y, element.position.z);
        matrix.compose(position, rotationQ, scale);
        textInstance.name = `${baseMesh.name}-${index}_instance`;
        textInstance.setMatrixAt(index, matrix);

        streetsGroup.add(textInstance);

    })

    return streetsGroup;
}

export const toggleStreetNames = (show) => {
    const group = threeJsVariables.scene.getObjectByName('streetsGroup');

    if (!group) return;

    group.visible = show;
}

export const rotateStreetNames = () => {
    const group = threeJsVariables.scene.getObjectByName('streetsGroup');
    if (!group) return;

    const indicator = rotateToCamera();

    group.traverse(child => {

        if (child.type === 'Group') return;

        if (indicator > 1.5) {
           child.rotation.z = 1.2;
       } else if (indicator < 1.5) {
            child.rotation.z = -2;
        }

    })
}
